import React from "react";
import { Input } from "@/components/ui/input";

interface SearchBarProps {
  value: string;
  onChange: (value: string) => void;
}

const SearchBar: React.FC<SearchBarProps> = ({ value, onChange }) => {
  return (
    <Input
      placeholder="Search guest, unit # or tracking..."
      value={value}
      onChange={e => onChange(e.target.value)}
      data-testid="package-search"
      className="w-full min-w-[120px] max-w-lg"
    />
  );
};

export default SearchBar;